// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__35Vq4","buttons":"RemoveExpirationActionButtons_buttons__1DGii"};